import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/video/${video.id}`}
      className="group block cursor-pointer"
    >
      {/* Thumbnail */}
      <div
        className={`relative overflow-hidden rounded-lg mb-3 bg-background-200 ${
          isLarge ? 'aspect-video' : 'aspect-video'
        }`}
      >
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 蓝莓视频高清在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-75 group-hover:scale-100">
            <i className="ri-play-fill text-foreground-950 text-xl ml-0.5"></i>
          </div>
        </div>
        {/* Duration Badge */}
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/75 text-foreground-950 text-xs font-medium whitespace-nowrap">
          {video.duration}
        </span>
        {/* Rating Badge */}
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-foreground-950 text-xs font-bold whitespace-nowrap">
          {video.rating}
        </span>
        {/* Hot Badge */}
        {video.isHot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-bold whitespace-nowrap">
            热播
          </span>
        )}
        {/* New Badge */}
        {video.isNew && !video.isHot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-secondary-500 text-foreground-950 text-xs font-bold whitespace-nowrap">
            新上
          </span>
        )}
      </div>

      {/* Info */}
      <div className={isLarge ? 'px-1' : 'px-1'}>
        <h3
          className={`font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors ${
            isLarge ? 'text-base md:text-lg' : 'text-sm md:text-[14px]'
          }`}
        >
          {video.title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5">
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line text-[10px]"></i>
            {video.views}
          </span>
          <span className="text-xs text-foreground-400">
            {video.releaseDate}
          </span>
        </div>
      </div>
    </Link>
  );
}